import Button from '../Button';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { getAuthentication } from '@/hooks/useAuthentication';
import { useResponsiveImage } from '@/utils/useResponsiveImage';
import { useState } from 'react';
import { OnBoardingPage } from '@edwin-group/cj-graphql';

interface OnBoardingContainerProps {
  page?: OnBoardingPage;
  image?: string;
  title: string;
  description?: string;
  step?: number;
  button: {
    text: string;
    onClick: () => void;
  };
  content?: React.ReactNode;
}
export default function OnBoardingContainer({
  page,
  image,
  title,
  description,
  step,
  button,
  content,
}: OnBoardingContainerProps) {
  const navigate = useNavigate();
  const { src } = useResponsiveImage({ url: image || '', alternativeText: '' });
  const [imageLoaded, setImageLoaded] = useState(false);
  const [logoLoaded, setLogoLoaded] = useState(false);

  if (title == '') {
    return null;
  }

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.7 }}
      className={`flex flex-col items-center justify-center ${logoLoaded ? 'block' : 'hidden'}`}>
      <div className="my-10 flex flex-col items-center justify-center">
        <p className=" text-sh-md font-bold">Welcome to</p>
        <img src={page?.logo?.url || ''} alt="onboarding-bg" width={250} onLoad={() => setLogoLoaded(true)} />
      </div>

      <div className="grid-cols1 grid items-center justify-center gap-6 md:grid-cols-2">
        {image && src && (
          <img
            src={src || ''}
            alt=""
            width={430}
            height={287}
            className="mb-7 transition-all duration-300 ease-in"
            onLoad={() => setImageLoaded(true)}
          />
        )}

        {((image && imageLoaded) || !image) && (
          <div className="flex h-full flex-col justify-center">
            <div>
              <h1 className="mb-4 font-cadiz text-sh-28-32 font-bold">{title}</h1>
              {!content && (
                <div className="mb-4">
                  <p className="font-cadiz text-sh-14-18">{description}</p>
                </div>
              )}

              {content && content}
              {(step || 0) > 0 && (
                <Button
                  theme="outline"
                  onClick={() => {
                    const stepUrl = `/on-boarding/step-${step || 0}`;
                    localStorage.setItem(`current-step-${getAuthentication()?.user?.id}`, stepUrl);
                    navigate(stepUrl);
                  }}
                  className="mb-3 mr-sh-15">
                  Back
                </Button>
              )}
              <Button theme="solid" onClick={button.onClick}>
                {button.text}
              </Button>
            </div>
          </div>
        )}
      </div>
    </motion.div>
  );
}
